import{k as e}from"./chunk-FOKZPL3K.js";import{a}from"./chunk-FDKODXIE.js";import{m as n}from"./chunk-HBP5N4FR.js";n();function g(t){let o=e(a.getState()),r=Object.keys(t).length===(o==null?void 0:o.transactions.length);return t&&(t&&r)}export{g as a};
//# sourceMappingURL=chunk-CNQDR77M.js.map
